import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export function reviewsSwiper() {
  Swiper.use([Navigation, Pagination]);

  const swiperElContent = document.querySelector('[data-reviews-swiper-content]');
  const swiperContent = new Swiper(swiperElContent, {
    slidesPerView: 3,
    spaceBetween: 20,
    navigation: {
      nextEl: '[data-reviews-swiper-content-next]',
      prevEl: '[data-reviews-swiper-content-prev]',
    },
    breakpoints: {
      1200: {
        spaceBetween: 0,
        slidesPerView: 3,
      },
      576: {
        slidesPerView: 2,
      },
      320: {
        slidesPerView: 1,
        spaceBetween: 30,
      },
    },
  });


  const swiperElText = document.querySelector('[data-reviews-swiper-text]');
  const swiperText = new Swiper(swiperElText, {
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: {
      nextEl: '[data-reviews-swiper-text-next]',
      prevEl: '[data-reviews-swiper-text-prev]',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      1200: {
        spaceBetween: 0,
      },
    },
  });
}
